import { Component } from '@angular/core';

@Component({
  selector: 'app-subventions-home',
  templateUrl: './subventions-home.component.html',
  styleUrls: ['./subventions-home.component.scss'],
})
export class SubventionsHomeComponent {}
